/** Display helpers for the Reference Values page. */

export const formatValue = (value, unit) => {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  if (unit === 'percent') return `${number}%`;
  return `$${number.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
};

export const formatWhen = (iso) => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
};

/** A stable id for a (year, key) row. */
export const rowId = (row) => `${row.year}|${row.value_key}`;

/** Rows with a proposal waiting, oldest year first, in catalog order. */
export const pendingRows = (rows, catalogOrder) => rows
  .filter((row) => row.proposed)
  .sort((a, b) => (a.year === b.year
    ? (catalogOrder[a.value_key] ?? 999) - (catalogOrder[b.value_key] ?? 999)
    : a.year.localeCompare(b.year)));

/** The years shown as tabs: every year with a row, plus this year and next. */
export const yearsShown = (rows, currentYear) => {
  const years = new Set(rows.map((row) => row.year));
  years.add(String(currentYear));
  years.add(String(currentYear + 1));
  return [...years].sort();
};

/**
 * For one year: every catalog value, grouped by category, with its stored row
 * (or none yet), so a missing value can be set by hand.
 */
export const yearTable = (catalog, rows, year) => {
  const byKey = {};
  rows.filter((row) => row.year === year).forEach((row) => { byKey[row.value_key] = row; });
  return catalog.categories.map((category) => ({
    ...category,
    entries: catalog.values
      .filter((spec) => spec.category === category.key)
      .map((spec) => ({ spec, row: byKey[spec.key] || null })),
  }));
};

/** What the last run did, in a few words. */
export const runSummary = (run) => {
  if (!run) return 'No refresh has run yet.';
  const counts = run.counts || {};
  const parts = [];
  if (counts.proposed) parts.push(`${counts.proposed} new to review`);
  if (counts.verified) parts.push(`${counts.verified} confirmed unchanged`);
  if (counts.proposal_withdrawn) parts.push(`${counts.proposal_withdrawn} proposals withdrawn`);
  if (!parts.length) parts.push('no changes');
  const failures = (run.failures || []).length;
  if (failures) parts.push(`${failures} problem${failures === 1 ? '' : 's'}`);
  return parts.join(', ');
};
